import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFormatCurrency } from '@src/hooks/useFormatCurrency'

import {
  DiscountText,
  TermsText,
  SingleDiscountContainer,
  CouponAndTextContainer,
  CouponLargeCircle,
  TitleAndTermsContainer,
  StyledAddOnItemsSVG,
} from './SingleDiscounts.styles'

export const AddOnItemsOffer: React.FC<{
  parentMenuName?: string
  minimumBasketTotalForAddOns: number | null
}> = ({ parentMenuName, minimumBasketTotalForAddOns }) => {
  const { t } = useTranslation('addOnItems')
  const formatCurrency = useFormatCurrency()

  const addOnDescription = minimumBasketTotalForAddOns
    ? t('offered_on_orders_over', {
        orderAmount: formatCurrency(minimumBasketTotalForAddOns),
      })
    : t('offered_on_all_orders')

  return (
    <SingleDiscountContainer isAddOn>
      <CouponAndTextContainer>
        <CouponLargeCircle isAddOn>
          <StyledAddOnItemsSVG id="basket-boost" />
        </CouponLargeCircle>
        <TitleAndTermsContainer>
          <DiscountText isAddOn>{parentMenuName}</DiscountText>
          <TermsText>{addOnDescription}</TermsText>
        </TitleAndTermsContainer>
      </CouponAndTextContainer>
    </SingleDiscountContainer>
  )
}
